import { render } from "./DominanceView.vue?vue&type=template&id=d427394c&scoped=true"
import script from "./DominanceView.vue?vue&type=script&lang=js"
export * from "./DominanceView.vue?vue&type=script&lang=js"

import "./DominanceView.vue?vue&type=style&index=0&id=d427394c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d427394c"]])

export default __exports__